import RefreshIcon from '@mui/icons-material/Refresh';

import ButtonComponent from "../../components/buttonComponent";

const ResetOrdersHeader = ({ getTableData }) => {
  const handleClick = () => {
    getTableData();
  };
  return (
    <div className="flex flex-nowrap space-x-2 w-full pl-2 mr-0 justify-between">
      <div class="w-1/3 pt-2"></div>
      <div className="w-1/3 pt-2">
        <b id="reset-orders-title" className="text-xs">Reset Orders</b>
      </div>
      <ButtonComponent handleFunction={handleClick} tooltip={"Refresh Data"} variant={null} >
        <RefreshIcon style={{ fontSize: '20px' }} />
      </ButtonComponent>
    </div>
  );
};

export default ResetOrdersHeader;
